let erpMerchList = []
let brandList = []
let storehouseList = []
let shelvesList = []
let managerList = []
let categoryTreeList = []
let supplierList = []
let unitList = []
let expireList = []
let checkList = [{id: '1', name: '是'}, {id: '0', name: '否'}]
let inStockTypeList = []
let outStockTypeList = []
let userStoreHouseList = []

export default {
  erpMerchList,
  brandList,
  storehouseList,
  shelvesList,
  managerList,
  categoryTreeList,
  supplierList,
  unitList,
  expireList,
  checkList,
  inStockTypeList,
  outStockTypeList,
  userStoreHouseList
}



// WEBPACK FOOTER //
// ./src/store/erp/state.js